import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Calendar, MessageCircle, Mic, BookOpen, Presentation, Bus, Gamepad2, Sparkles, Star } from 'lucide-react';

function EtkinliklerPage() {
  const { slug } = useParams();
  
  useEffect(() => {
    window.scroll(0, 0);
  }, [slug]);

  const starryBackground = {
    backgroundImage: `
      radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.8), transparent),
      radial-gradient(2px 2px at 60px 70px, rgba(255,255,255,0.6), transparent),
      radial-gradient(1px 1px at 50px 50px, rgba(255,255,255,0.4), transparent),
      radial-gradient(1px 1px at 130px 80px, rgba(255,255,255,0.5), transparent),
      radial-gradient(2px 2px at 90px 10px, rgba(255,255,255,0.7), transparent),
      radial-gradient(1.5px 1.5px at 180px 120px, rgba(255,255,255,0.6), transparent),
      radial-gradient(1px 1px at 200px 180px, rgba(255,255,255,0.4), transparent),
      radial-gradient(2px 2px at 250px 50px, rgba(255,255,255,0.8), transparent)
    `,
    backgroundSize: '200px 200px, 300px 300px, 400px 400px, 250px 250px, 350px 350px, 280px 280px, 320px 320px, 380px 380px',
    animation: 'starAnimation 60s linear infinite'
  };

  const events = [
    {
      icon: MessageCircle,
      title: 'ACMen Talks',
      description: [
        'ACMen Talks, belirli bir tema etrafında toplanan katılımcıların hem İngilizce hem de Türkçe terimlerle etkileşime girdiği, özgün bir konuşma pratiği etkinliğidir. Etkinlik sırasında, tema ile ilgili kilit terimler ve kavramlar açıklanarak katılımcılara sunulur. Katılımcılar bu terimleri kullanarak, derinlemesine tartışmalar yapma fırsatı bulur.',
        'Bu etkinlik, özellikle İngilizce konuşma konusunda kendine güven kazanmak isteyenler için idealdir. Katılımcılar, hem bireysel hem de grup halinde konuşma pratiği yaparak İngilizce yetkinliklerini artırırken, konuşma sırasında yaptıkları hataların anında düzeltilmesi sayesinde dil öğrenim süreçlerini hızlandırırlar.'
      ],
      color: 'blue'
    },
    {
      icon: Mic,
      title: 'Teknik Söyleşiler',
      description: [
        'Teknik Söyleşiler, teknolojiye ilgi duyan herkesin buluştuğu, sıcak ve samimi bir ortam sunuyor. Bu etkinliklerde, sektörün deneyimli profesyonelleri ve liderleriyle bir araya geliyoruz. Onların eşsiz hikayelerini, karşılaştıkları zorlukları ve edindikleri tecrübeleri dinleme fırsatı buluyoruz. Teknolojinin her alanında merak ettiğiniz soruları sorma ve yeni ufuklar keşfetme şansınız var.'
      ],
      color: 'purple'
    },
    {
      icon: BookOpen,
      title: 'Tekno Bilgi Günleri',
      description: [
        'Tekno Bilgi Günleri, üyelerimizin teknoloji ve bilim alanında bilgi paylaşımında bulunduğu etkinliklerdir. Her hafta belirlenen bir tema üzerinde derinlemesine sunumlar ve tartışmalar yaparız. Katılımcılar, hem güncel gelişmeleri takip eder hem de yeni bilgiler edinirler. Bu etkinlik, teknolojiye merak duyan herkes için mükemmel bir öğrenme ve paylaşım platformudur.'
      ],
      color: 'cyan'
    },
    {
      icon: Presentation,
      title: 'Sunum Günleri',
      description: [
        'Sunum Günleri, üyelerimizin ilgi duydukları konularda sunumlar yaparak bilgilerini paylaştıkları ve birlikte öğrendikleri bir etkinliktir. Bu platformda, katılımcılar hem yeni bilgiler edinir hem de sunum ve iletişim becerilerini geliştirirler. Farklı alanlarda ilgi çekici konular keşfetmek, fikir alışverişinde bulunmak ve topluluk önünde konuşma deneyimi kazanmak isteyen herkes için harika bir fırsat!'
      ],
      color: 'green'
    },
    {
      icon: Bus,
      title: 'Teknik Geziler',
      description: [
        'Teknik Geziler, teknoloji ve bilişim dünyasının kalbine yaptığımız keşif dolu yolculuklardır. Bu etkinliklerde, önde gelen teknoloji şirketlerini, araştırma merkezlerini ve inovasyon odaklı kuruluşları ziyaret ediyoruz. Katılımcılar, sektörün nasıl işlediğini yakından görme, profesyonellerle tanışma ve ilham verici deneyimler yaşama fırsatı buluyor.'
      ],
      color: 'orange'
    },
    {
      icon: Gamepad2,
      title: 'Fundays',
      description: [
        'Fundays, eğlence ve rekabetin bir araya geldiği özel bir etkinliktir. Bu günlerde, farklı temalarda düzenlenen oyunlar, yarışmalar ve aktivitelerle hem keyifli vakit geçirebilir hem de yeni arkadaşlıklar edinebilirsiniz. Strateji oyunlarından bilgi yarışmalarına, takım etkinliklerinden sürpriz aktivitelere kadar her şey sizi bekliyor!'
      ],
      color: 'pink'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'from-blue-500/20 to-blue-600/10 border-blue-500/30 text-blue-400',
      purple: 'from-purple-500/20 to-purple-600/10 border-purple-500/30 text-purple-400',
      cyan: 'from-cyan-500/20 to-cyan-600/10 border-cyan-500/30 text-cyan-400',
      green: 'from-green-500/20 to-green-600/10 border-green-500/30 text-green-400',
      orange: 'from-orange-500/20 to-orange-600/10 border-orange-500/30 text-orange-400',
      pink: 'from-pink-500/20 to-pink-600/10 border-pink-500/30 text-pink-400'
    };
    return colors[color] || colors.blue;
  };

  return (
    <div 
      className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-950 to-slate-900 pt-28 pb-16 px-5 relative overflow-hidden"
      style={starryBackground}
    >
      {/* Dekoratif elementler */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-900/10 to-transparent pointer-events-none" />
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 right-10 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="p-3 bg-purple-500/20 rounded-2xl backdrop-blur-sm border border-purple-500/30">
              <Calendar className="w-8 h-8 text-purple-400" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight">
              Etkinliklerimiz
            </h1>
          </div>
          <p className="text-blue-200/60 text-lg max-w-2xl mx-auto">
            ACM Iğdır olarak düzenlediğimiz etkinliklerle kendinizi geliştirin
          </p>
          <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 rounded-full border border-purple-500/20">
            <Star className="w-4 h-4 text-yellow-400" />
            <span className="text-purple-200/80 text-sm">{events.length} farklı etkinlik türü</span>
          </div>
        </div>

        {/* Events Grid */}
        <div className="space-y-6">
          {events.map((event, index) => {
            const IconComponent = event.icon;
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-3xl border border-white/10 p-8 md:p-10 transition-all duration-500 hover:border-white/20 hover:scale-[1.01]"
                style={{ animation: `slideInUp 0.5s ease-out ${index * 0.1}s backwards` }}
              >
                <div className="flex flex-col md:flex-row items-start gap-6">
                  {/* Icon */}
                  <div className={`p-4 rounded-2xl bg-gradient-to-br ${getColorClasses(event.color)} border flex-shrink-0`}>
                    <IconComponent className="w-8 h-8" />
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 group-hover:text-blue-300 transition-colors">
                      {event.title}
                    </h2>
                    <div className="space-y-3">
                      {event.description.map((paragraph, pIndex) => (
                        <p key={pIndex} className="text-blue-100/70 leading-relaxed">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-purple-500/10 to-blue-500/10 rounded-full border border-white/10">
            <Sparkles className="w-5 h-5 text-purple-400" />
            <span className="text-blue-200/80">Tüm etkinliklerimize katılmak için üye olun!</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EtkinliklerPage;
